// 시작일과 종료일로부터 개월 수를 계산하는 유틸 함수
export const calculateMonthsDuration = (
  startDate: string,
  endDate: string,
): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  // 연도와 월 차이를 정확히 계산
  const yearDiff = end.getFullYear() - start.getFullYear();
  const monthDiff = end.getMonth() - start.getMonth();

  return yearDiff * 12 + monthDiff;
};
